export const name = 'LastLocationManager'
